import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "../lib/api";
import Logo from "../components/Logo";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@dhaddamotionpictures.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.login(email, password);
      setToken(res.access_token);
      toast.success("Welcome back, Director.");
      nav("/admin");
    } catch (err) {
      toast.error("Invalid credentials.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-onyx-900 p-6" data-testid="admin-login-page">
      <div className="absolute inset-0 grain pointer-events-none" />
      <form onSubmit={submit} className="relative w-full max-w-md gold-border bg-onyx-800 p-10" data-testid="admin-login-form">
        <div className="flex flex-col items-center mb-10">
          <Logo size={110} withText />
          <h1 className="mt-6 font-display text-3xl text-ivory">Director's Suite</h1>
          <p className="mt-2 font-cinzel text-[10px] tracking-[0.3em] uppercase text-gold/70">
            Authenticated Access Only
          </p>
        </div>
        <div className="space-y-7">
          <div>
            <label className="font-cinzel text-[9px] tracking-[0.3em] uppercase text-gold/70">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-cinema mt-2 w-full"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="font-cinzel text-[9px] tracking-[0.3em] uppercase text-gold/70">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-cinema mt-2 w-full"
              data-testid="admin-password-input"
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={busy}
          className="mt-10 w-full bg-gold hover:bg-gold-bright disabled:opacity-50 py-4 font-cinzel text-[11px] tracking-[0.3em] uppercase text-onyx-900 transition-colors"
          data-testid="admin-login-submit"
        >
          {busy ? "Authenticating…" : "Sign In"}
        </button>
        <p className="mt-6 text-center text-xs text-ivory/40">
          Trouble? Contact your producer.
        </p>
      </form>
    </div>
  );
}
